import { useQuestReportWorkOrderCost } from '@/core/domain/questReport/WorkOrder/WorkOder.hooks';
import { QuestReportWorkOrderCostRequest } from '@/core/domain/questReport/WorkOrder/WorkOrder.types';
import { useReportGenerate } from '@/hooks';
import { FileType } from '@/hooks/useFileLoading';
import { Checkbox, Col, Form, Modal, ModalProps, Row } from 'antd';
import { useForm } from 'antd/lib/form/Form';

interface Props extends Omit<ModalProps, 'onCancel'> {
  onCancel: VoidFunction;
  workOrderId?: number;
  complementNumber?: number;
  format?: FileType;
  licensePlate?: string;
  workorderNumber?: number;
  complementIdentifier?: string;
}

export default function WorkOrderReportWorkOrderCostModal({
  onCancel,
  workOrderId,
  format,
  licensePlate,
  complementIdentifier,
  ...props
}: Props) {
  const [form] = useForm<{ showFinancial: boolean }>();
  const costReport = useQuestReportWorkOrderCost();

  const report = useReportGenerate();

  function handleCancel() {
    onCancel();
    form.resetFields();
  }

  const handleOk = async () => {
    const values = await form.validateFields();

    if (!!workOrderId) {
      const obj: QuestReportWorkOrderCostRequest = {
        workOrderId,
        ...values,
      };

      const result = await costReport.mutateAsync(obj);

      const fileName = `relatorio-custo-os${
        complementIdentifier ? `-${complementIdentifier}` : ''
      }${licensePlate ? `-${licensePlate}` : ''}.pdf`;

      if (format === 'PDF') {
        report.downloadFile({
          result,
          fileName,
        });
      } else {
        report.openFile({
          result,
          fileName,
          fileType: 'application/pdf',
        });
      }

      handleCancel();
    }
  };

  return (
    <Modal
      width={800}
      title="Custo da OS"
      okText="Gerar relatório"
      confirmLoading={costReport.isLoading}
      zIndex={2000}
      onOk={handleOk}
      onCancel={handleCancel}
      destroyOnClose
      {...props}
    >
      <Form form={form}>
        <Row gutter={[16, 16]}>
          <Col span={24}>
            <Form.Item name="ShowFinancial" valuePropName="checked" noStyle>
              <Checkbox>Exibir dados do financeiro gerado</Checkbox>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
}
